import { DatePicker as DatePickerAntd } from 'antd';
import type { Moment } from 'moment';
import momentGenerateConfig from 'rc-picker/lib/generate/moment';

const DatePicker = DatePickerAntd.generatePicker<Moment>(momentGenerateConfig);

export { DatePicker };
